import React from "react"
import { styled } from "themes"
import { Headline as StyledHeadline } from "components"
import { Markdown } from "components"
import { ReactMarkdownProps } from "react-markdown"
import { Popover, Button } from "antd"
import { DownOutlined } from "@ant-design/icons"

export const Section = styled.section``

export const Container = styled.div``

export const Headline = styled((props: any) => <StyledHeadline {...props} />)`
  margin-left: 20px;
  margin-right: 20px;
`

export const Detail = styled.div`
  display: flex;
  justify-content: space-between;
`

export const Description = styled((props: ReactMarkdownProps) => (
  <Markdown {...props} />
))`
  padding: 34px;
  margin-bottom: 0;
  max-width: 496px;
  > p {
    font-size: 14px;
  }
`

export const Filter = styled.div``

export const FilterIcon = styled((props: any) => <DownOutlined {...props} />)`
  &&.anticon {
    margin-left: 24px;
  }
`

export const StyledButton = styled((props: any) => <Button {...props} />)`
  && {
    font-size: 12px;
    text-transform: uppercase;
    font-weight: 500;
    border-radius: 4px;
  }
`

export const StyledPopover = styled((props: any) => (
  <Popover placement="bottom" {...props} />
))``

export const List = styled.div`
  display: flex;
`

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 12px;
`

export const ListItem = styled.div`
  margin-bottom: 12px;
  &:last-child {
    margin-bottom: 0;
    flex: 1;
  }
`

export const PaginationWrapper = styled.div`
  display: flex;
  justify-content: center;
  padding-top: 64px;
  padding-bottom: 32px;
`

export const ShareWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
`

export const FilterList = styled.ul`
  list-style: none;
  padding: 0;
  margin-bottom: 0;
`

export const FilterListItem = styled.li`
  text-transform: uppercase;
  text-align: center;
  font-size: 12px;
  line-height: 15px;
  padding: 12px 0;
  cursor: pointer;
`
